export default __webpack_public_path__ + "f8cc7c5bcac7f7d7a458ef105c419303.svg";